module.exports = __webpack_public_path__ + "static/media/nova-new-neutral-full.1c09adb1.png";